"use client";

import { ReactNode } from "react";

export default function Heading({ children }: { children: ReactNode }) {
  return (
    <div className="border border-primary/30 p-2 md:p-4 mb-3 relative">
      <div className="border-t-6 border-l-6 border-primary absolute size-4 -top-1 -left-1"></div>
      <div className="border-t-6 border-r-6 border-primary absolute size-4 -top-1 -right-1"></div>
      <div className="border-b-6 border-l-6 border-primary absolute size-4 -bottom-1 -left-1"></div>
      <div className="border-b-6 border-r-6 border-primary absolute size-4 -bottom-1 -right-1"></div>
      <h2 className="md:text-4xl text-3xl text-center font-bold text-secondary">
        {children}
      </h2>
    </div>
  );
}
